import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHeroSection from './sections/AboutHeroSection';
import AboutStorySection from './sections/AboutStorySection';
import CredentialsAffiliationSection from './sections/CredentialsAffiliationSection';
import ApproachSection from './sections/ApproachSection';
import AboutTestimonialsSection from './sections/AboutTestimonialsSection';
import AboutNoteSection from './sections/AboutNoteSection';
import AboutCtaSection from './sections/AboutCtaSection';

const SectionDivider = () => (
  <div className="w-full h-px bg-accent-500/30" />
);

export default function About() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <AboutHeroSection />
        <SectionDivider />
        <AboutStorySection />
        <SectionDivider />
        <CredentialsAffiliationSection />
        <SectionDivider />
        <ApproachSection />
        <SectionDivider />
        <AboutTestimonialsSection />
        <SectionDivider />
        <AboutNoteSection />
        <SectionDivider />
        <AboutCtaSection />
      </main>
      <Footer />
    </div>
  );
}